import React from 'react';
import { Card, Statistic } from 'antd';

interface SummaryStatisticCardProps {
    title: string;
    value: number;
    prefix?: React.ReactNode;
    suffix?: string;
}

export const SummaryStatisticCard: React.FunctionComponent<SummaryStatisticCardProps> = ({
    title,
    value,
    prefix,
    suffix
}) => {
    return (
        <Card>
            <Statistic
                title={title}
                value={value}
                prefix={prefix}
                suffix={suffix}
            />
        </Card>
    );
};
